import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const fetchDataRequest = createAction("".concat(stateName, "/fetchDataRequest"));
export const fetchDataFailure = createAction("".concat(stateName, "/fetchDataFailure"));
export const fetchBrandsRequest = createAction("".concat(stateName, "/fetchBrandsRequest"), function () {
  let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    payload: {
      query
    }
  };
});
export const fetchBrandsFailure = createAction("".concat(stateName, "/fetchBrandsFailure"));
export const fetchBrandRequest = createAction("".concat(stateName, "/fetchBrandRequest"));
export const applyPersonalizedSizesRequest = createAction("".concat(stateName, "/applyPersonalizedSizesRequest"));
export const applyPersonalizedSizesFailure = createAction("".concat(stateName, "/applyPersonalizedSizesFailure"));
export const fetchDynamicFilterSearchRequest = createAction("".concat(stateName, "/fetchDynamicFilterSearchRequest"), function (code) {
  let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    payload: {
      text,
      code
    }
  };
});
export const fetchDynamicFilterSearchFailure = createAction("".concat(stateName, "/fetchDynamicFilterSearchFailure"));